'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import config from 'config'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactSlidedown = require('react-slidedown');

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _ = require('../');

var _PlanScorecardShareholderResolution = require('./PlanScorecardShareholderResolution.css');

var _PlanScorecardShareholderResolution2 = _interopRequireDefault(_PlanScorecardShareholderResolution);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanScorecardShareholderResolution = (_dec = (0, _reactCssModules2.default)(_PlanScorecardShareholderResolution2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlanScorecardShareholderResolution, _Component);

  function PlanScorecardShareholderResolution(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardShareholderResolution);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlanScorecardShareholderResolution.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardShareholderResolution)).call(this, props));

    _this.state = {
      open: props.url.hash === '#resolution'
    };
    return _this;
  }

  (0, _createClass3.default)(PlanScorecardShareholderResolution, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          planId = _props.planId,
          planData = _props.planData;
      var open = this.state.open;

      // companies that have resolutions

      var resolutionTexts = {
        'amazon-com': _react2.default.createElement(_.AmazonResolutionText, null),
        'comcast': _react2.default.createElement(_.ComcastResolutionText, null),
        'microsoft': _react2.default.createElement(_.MicrosoftResolutionText, null),
        'campbell-soup': _react2.default.createElement(_.CampbellSoupResolutionText, null)
      };

      // nothing if no resolution text
      if (!(0, _keys2.default)(resolutionTexts).includes(planId)) {
        return null;
      }

      // from plan data, sum:
      //   TD deforest $USD
      //   equity deforest $USD
      //   TD fossil fuel $USD
      //   equity fossil fuel $USD
      var climateRiskInvestments = _format2.default.money(planData.screen_results.dff[0] + planData.screen_results.dff[1] + planData.screen_results.fff[0] + planData.screen_results.fff[1], true, true);

      return _react2.default.createElement(
        'div',
        { styleName: 'plan-scorecard-company-resolution' },
        _react2.default.createElement('div', { styleName: 'anchor', id: 'resolution' }),
        _react2.default.createElement(
          'button',
          {
            styleName: 'section-slidedown-button',
            onClick: function onClick(e) {
              _this2.setState({
                open: !open
              });
            }
          },
          _react2.default.createElement(
            'h2',
            { styleName: 'section-slidedown-label' },
            'Our shareholder resolution'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'section-slidedown-icon' },
            _react2.default.createElement(_.LinkIcon, { faclass: open ? 'fa-angle-up' : 'fa-angle-down' })
          )
        ),
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          open ? _react2.default.createElement(
            'div',
            null,
            /* EXPIRED */
            planId === 'amazon-com' || planId === 'campbell-soup' || planId === 'comcast' || planId === 'microsoft' ? _react2.default.createElement(
              'p',
              null,
              'We filed a shareholder resolution that went to vote at ',
              planData.short_name,
              '\'s most recent Annual General Meeting. Our resolution asked: Why is the company saying \u201C',
              planData.climate_claim,
              ',\u201D and at the same time directing ',
              climateRiskInvestments,
              ' of employee savings into fossil fuels and rainforest destruction? Click through below to learn more about the results for this resolution.'
            ) : null,
            resolutionTexts[planId]
          ) : null
        )
      );
    }
  }]);
  return PlanScorecardShareholderResolution;
}(_react.Component), _class2.propTypes = {
  planId: _react.PropTypes.string.isRequired,
  planData: _react.PropTypes.object.isRequired,
  url: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = PlanScorecardShareholderResolution;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardShareholderResolution/PlanScorecardShareholderResolution.js
// module id = 1426
// module chunks = 0